import React from "react";
import CollectionSearchDropdown from "./CollectionSearchDropdown";

export default function ArtistSearchDropdown({ onSelect, ...props }) {
  return (
    <CollectionSearchDropdown
      {...props}
      types="artist"
      onSelect={(result) => onSelect(result.item)}
    />
  );
}
